<template>
  <el-submenu
    v-if="hasPermission('feature_group:marketing')"
    index="/marketing">
    <template slot="title">
      <div @click="$emit('click')">
        <navigation-icon
          name="marketing"/>
        Marketing
      </div>
    </template>
    <!--
      Required for Element to register
      submenu as active. Does not display.
     -->
    <el-menu-item
      v-show="false"
      class="side-navigator__menu-item"
      index="/marketing">
      Marketing
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('role:super_admin')"
      index="/deals"
      class="side-navigator__menu-item">
      Deals
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:marketing:campaigns')"
      :index="hasPermission('role:retailer') ? '/promotions' : '/campaigns'"
      class="side-navigator__menu-item">
      {{ hasPermission('role:retailer') ? 'Promotions' : 'Campaigns' }}
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:marketing:stores')"
      index="/marketing/stores"
      class="side-navigator__menu-item">
      Stores
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:marketing:videos')"
      class="side-navigator__menu-item"
      index="/videos">
      Library
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:springserve')"
      class="side-navigator__menu-item"
      index="/video/springservevideos">
      SpringServe Videos
    </el-menu-item>
  </el-submenu>
</template>

<script>
import MarketingIcon from './icons/MarketingIcon'
import NavigationIcon from './NavigationIcon'

export default {
  name: 'MarketingNavigationGroup',
  components: {
    MarketingIcon,
    NavigationIcon,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/MarketingNavigationGroup.vue